module.exports = __webpack_public_path__ + "img/success.b5d70b08.gif";